import * as React from 'react'
import { useAlerts } from './AlertsProvider'
import useTranslation from '../../shared/TranslationProvider'

export function ViewJobsCell({ row }) {
  const { fetchAlertJobCount, createTransitionNotification } = useAlerts()
  const [numJobs, setNumJobs] = React.useState()
  const alert = row.original
  const {
    what,
    where,
    employment_type,
    job_type,
    employment_level,
    company_name,
  } = alert
  const { t } = useTranslation('DataTable')

  React.useEffect(() => {
    const getJobCount = () => {
      fetchAlertJobCount(alert)
        .then((res) => {
          setNumJobs(res.data.job_count)
          return res
        })
        .catch((err) => {
          console.log(err)
          return err
        })
    }
    getJobCount()
  }, [alert, fetchAlertJobCount])

  const viewJobsText = numJobs
    ? numJobs === 1
      ? t('view_job')
      : t('view_num_jobs', { numJobs })
    : t('view_jobs')

  const whatParam = what ? `what=${what}` : ''

  const companyParam = company_name ? `company_name=${company_name}` : ''

  const whereParam = where ? `where=${where}` : ''

  const getParams = (types, filterStr) => {
    let str = ''
    if (typeof types === 'string') {
      return `${filterStr}=${types}`
    }
    types.forEach((type) => {
      str += `${filterStr}=${type}&`
    })
    return str.slice(0, -1) // Remove the trailing '&'
  }

  // onsite, remote, hybrid
  const employmentTypeParam =
    employment_type?.length > 1 || employment_type?.[0].length > 0
      ? getParams(employment_type, 'filter_employment_type[]')
      : ''

  // full_time, part_time, contract, internship
  const jobTypeParam =
    job_type?.length > 1 || job_type?.[0].length > 0
      ? getParams(job_type, 'filter_job_type[]')
      : ''

  // internship, entrylevel, midseniorlevel, manager, director, executive
  const employmentLevelParam =
    employment_level?.length > 1 || employment_level?.[0].length > 0
      ? getParams(employment_level, 'filter_experience_level[]')
      : ''

  const queryExists =
    whatParam?.length > 0 ||
    whereParam?.length > 0 ||
    companyParam?.length > 0 ||
    employmentTypeParam?.length > 0 ||
    jobTypeParam?.length > 0 ||
    employmentLevelParam?.length > 0

  const query = [
    whatParam,
    whereParam,
    companyParam,
    employmentTypeParam,
    jobTypeParam,
    employmentLevelParam,
  ]
    .filter((param) => param)
    .join('&')

  const url = queryExists
    ? `/job-search/jobs?${query}&from=alerts`
    : `/job-search/jobs?from=alerts`

  return (
    <a
      onClick={() => createTransitionNotification('viewedResults')}
      title="view jobs"
      href={url}
    >
      {viewJobsText}
    </a>
  )
}
